import React from "react";
import styled from "styled-components";
import { StatusIcon } from "../../assets/svg/StatusIcon";
import { LabelText, TitleText } from "../../ui/Text";
import { get } from "../../utils/get";

interface IProps {
  backgroundColor?: string;
  data?: any;
}
export const TaskItem = ({ backgroundColor, data }: IProps) => {
  const getColor = (priority) => {
    switch (true) {
      case priority === "high":
        return "#D51067";
      case priority === "medium":
        return "#EDBC0C";
      default:
        return "#4BD041";
    }
  };
  return (
    <TaskItemContainer backgroundColor={backgroundColor}>
      <LabelText>
        Priority:{" "}
        <span
          style={{
            color: getColor(get(data, "priority")),
            paddingLeft: "0.5em",
            textTransform: "capitalize",
            alignItems: "center",
          }}
        >
          {get(data, "priority")}
          {"  "}
          <StatusIcon color={getColor(get(data, "priority"))} />
        </span>
      </LabelText>
      <TitleText>{get(data, "name")}</TitleText>
      <ImagesContainer>
        {get(data, "owners", []).map((owner) => (
          <ImageItem
            src={
              owner?.avatar_url ||
              `https://ui-avatars.com/api/?name=${owner?.owner_names}`
            }
            // alt="person1"
          />
        ))}
      </ImagesContainer>
    </TaskItemContainer>
  );
};
const TaskItemContainer = styled.div<{ backgroundColor?: string }>`
  display: grid;
  border: 1px solid #ebeeff;
  border-radius: 10px;
  grid-template-rows: auto auto auto;
  padding: 0.3em 1em;
  background-color: ${(props) => props.backgroundColor || "#fff"};
  margin-bottom: 0.5em;
  ${TitleText} {
    font-size: 14px;
    font-weight: bold;
  }
  ${LabelText} {
    font-size: 12px;
  }
`;
const ImagesContainer = styled.div`
  align-items: center;
  justify-content: center;
  margin-left: 10px;
`;
const ImageItem = styled.img`
  margin-left: -10px;
  border: 0.2em solid #fff;
  border-radius: 1em;
  width: 1.75em;
  height: 1.75em;
`;
